import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import {
  StoreManagementMasterStoreCreateParams,
  StoreManagementMasterStoreCreateResponse,
} from '@/services/StoreManagement/MasterStores/hooks/create/useStoreManagementMasterStoreCreate';
import { StoreManagementMasterStoreCreateOrUpdateParams } from '@/services/StoreManagement/MasterStores/hooks/createOrUpdate/useStoreManagementMasterStoreUpdateOrCreate';
import {
  StoreManagementMasterStoreSearchListParams,
  StoreManagementMasterStoreSearchListResponse,
} from '@/services/StoreManagement/MasterStores/hooks/serachList/useStoreManagementMasterStoreSearchList';
import { StoreManagementMasterStoreShowReqponse } from '@/services/StoreManagement/MasterStores/hooks/show/useStoreManagementMasterStoreShow';
import { StoreManagementMasterStoreUpdateParams } from '@/services/StoreManagement/MasterStores/hooks/update/useStoreManagementMasterStoreUpdate';
import { StoreManagementMasterStoreUpdateLinkedStatusParams } from '@/services/StoreManagement/MasterStores/hooks/UpdateLinkedStatus/useStoreManagementMasterStoreUpdateLinkedStatus';

interface Interface {
  searchList: (
    params: StoreManagementMasterStoreSearchListParams
  ) => Promise<StoreManagementMasterStoreSearchListResponse>;
  createOrUpdate: (
    params: StoreManagementMasterStoreCreateOrUpdateParams
  ) => Promise<void>;
  show: (id: number) => Promise<StoreManagementMasterStoreShowReqponse>;
  updateLinkedStatus: (
    id: number,
    params: StoreManagementMasterStoreUpdateLinkedStatusParams
  ) => Promise<void>;
  create: (
    params: StoreManagementMasterStoreCreateParams
  ) => Promise<StoreManagementMasterStoreCreateResponse>;
  update: (
    id: number,
    params: StoreManagementMasterStoreUpdateParams
  ) => Promise<void>;
}

export class StoreManagementMasterStoreService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async createOrUpdate(
    params: StoreManagementMasterStoreCreateOrUpdateParams
  ): Promise<void> {
    await this.restClient.put<
      StoreManagementMasterStoreCreateOrUpdateParams,
      void
    >(`${TABLET_API_ORIGIN}/dashboard-api/master-stores` as const, params);
  }

  public async searchList(
    params: StoreManagementMasterStoreSearchListParams
  ): Promise<StoreManagementMasterStoreSearchListResponse> {
    const queryParams = new URLSearchParams();
    queryParams.append('limit', String(params.limit));
    queryParams.append('current_page', String(params.currentPage));
    if (params.name !== '') queryParams.append('name', String(params.name));
    params.associateBrandIds.forEach((associateBrandId) => {
      queryParams.append('associate_brand_ids', String(associateBrandId));
    });
    params.authStoreIds.forEach((authStoreId) => {
      queryParams.append('auth_store_ids', String(authStoreId));
    });
    if (params.deliveryServiceIds) {
      params.deliveryServiceIds.forEach((deliveryServiceId) => {
        queryParams.append('delivery_service_ids', String(deliveryServiceId));
      });
    }
    return await this.restClient.get<StoreManagementMasterStoreSearchListResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/master-stores?${queryParams.toString()}` as const
    );
  }

  public async show(
    id: number
  ): Promise<StoreManagementMasterStoreShowReqponse> {
    return await this.restClient.get<StoreManagementMasterStoreShowReqponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/master-stores/${id}` as const
    );
  }

  public async updateLinkedStatus(
    id: number,
    params: StoreManagementMasterStoreUpdateLinkedStatusParams
  ): Promise<void> {
    return await this.restClient.patch<
      StoreManagementMasterStoreUpdateLinkedStatusParams,
      void
    >(
      `${TABLET_API_ORIGIN}/dashboard-api/master-stores/${id}/linked-status` as const,
      params
    );
  }

  public async create(
    params: StoreManagementMasterStoreCreateParams
  ): Promise<StoreManagementMasterStoreCreateResponse> {
    return await this.restClient.post<
      StoreManagementMasterStoreCreateParams,
      StoreManagementMasterStoreCreateResponse
    >(`${TABLET_API_ORIGIN}/dashboard-api/master-stores` as const, params);
  }

  public async update(
    id: number,
    params: StoreManagementMasterStoreUpdateParams
  ): Promise<void> {
    return await this.restClient.patch(
      `${TABLET_API_ORIGIN}/dashboard-api/master-stores/${id}` as const,
      params
    );
  }

  public async delete(id: number): Promise<void> {
    return await this.restClient.delete(
      `${TABLET_API_ORIGIN}/dashboard-api/master-stores/${id}` as const
    );
  }
}
